import { Injectable } from '@angular/core';
import { AddEmailModalComponent } from './add-email-modal.component';
import { NotificationFacade } from '@ridango/components';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class EmailModalService {
    constructor(
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {}

    public present(emailModal: AddEmailModalComponent): void {
        emailModal.completed.pipe(take(1)).subscribe((result) => {
            this.notification.removeAll();
            if (result.success) {
                this.notification.success(this.translate.instant('CONFIRMATION_EMAIL_SENT_TO_USER'));
            } else {
                this.notification.error(this.translate.instant(result.errorKey));
            }
        });

        emailModal.open();
    }
}
